module.exports = __webpack_public_path__ + "img/android.f32394f9.svg";